<script setup lang="ts">
import { PlusOutlined } from "@ant-design/icons-vue";
import { type TableColumnsType } from "ant-design-vue";
import { FormItemRest, useInjectFormItemContext } from "ant-design-vue/es/form";
import { NoFormStatus } from "ant-design-vue/es/form/FormItemContext";
import { ref, watch } from "vue";

const value = defineModel<AObject[]>({ default: () => [] });

const columns: TableColumnsType = [
	{
		title: "物品名称",
		dataIndex: "spu_name",
		key: "spu_name",
		width: 140,
		align: "center",
	},
	{
		title: "物品图片",
		dataIndex: "theme_img",
		key: "theme_img",
		width: 100,
		align: "center",
	},
	{
		title: "规格",
		dataIndex: "spec",
		key: "spec",
		width: 120,
		align: "center",
	},
	{
		title: "数量",
		dataIndex: "quantity",
		key: "quantity",
		width: 100,
		align: "center",
	},
	{
		title: "备注",
		dataIndex: "remark",
		key: "remark",
		width: 160,
		align: "center",
	},
	{
		title: "操作",
		dataIndex: "operate",
		key: "operate",
		width: 80,
		align: "center",
	},
];

const handleAddProduct = () => {
	open.value = true;
};

const formItemContext = useInjectFormItemContext();

const open = ref(false);

const handleAddSku = (selectedRows: AObject[]) => {
	const skuIds = value.value.map((item) => item.sku_id);
	const newSelectedRows = selectedRows.filter((row) => !skuIds.includes(row.sku_id));

	value.value = [...value.value, ...newSelectedRows];
};

const handleDelete = (index: number) => {
	value.value.splice(index, 1);
};

// 监听数据变化，通知外层 form-create 校验状态变更
watch(
	() => value.value,
	() => {
		formItemContext.onFieldChange();
	},
	{ deep: true }
);
</script>

<template>
	<FormItemRest>
		<NoFormStatus>
			<a-form :model="value">
				<a-table :columns="columns" bordered :dataSource="value" :pagination="false">
					<template #headerCell="{ column }">
						<template v-if="column.key === 'spu_name'">
							<span>
								<span class="text-error">*</span>
								物品名称
							</span>
						</template>
						<template v-if="column.key === 'quantity'">
							<span>
								<span class="text-error">*</span>
								数量
							</span>
						</template>
						<template v-if="column.key === 'operate'">
							<div
								class="gap-ty leading-mm text-primary flex cursor-pointer items-center justify-center"
								@click="handleAddProduct"
							>
								<span>选择产品</span>
								<PlusOutlined class="!text-primary" />
							</div>
						</template>
					</template>

					<template #bodyCell="{ column, record, index }">
						<template v-if="column.dataIndex === 'theme_img'">
							<a-image :width="80" :height="80" :src="record.theme_img"></a-image>
						</template>

						<template v-if="column.dataIndex === 'spec'">
							<span v-if="record.sku_id">{{ record.specs }}</span>

							<a-form-item v-else class="!mb-0">
								<a-input v-model:value="record.spec" placeholder="请输入规格" :maxlength="30" />
							</a-form-item>
						</template>
						<template v-if="column.dataIndex === 'quantity'">
							<a-form-item
								class="!mb-0"
								:name="[index, 'quantity']"
								:rules="[{ required: true, message: '请输入数量', type: 'number', min: 1 }]"
							>
								<a-input-number
									v-model:value="record.quantity"
									:min="1"
									:max="9999"
									:precision="0"
									placeholder="请输入数量"
									class="!w-full"
								/>
							</a-form-item>
						</template>
						<template v-if="column.dataIndex === 'remark'">
							<a-form-item class="!mb-0">
								<a-textarea
									v-model:value="record.remark"
									placeholder="请输入备注"
									auto-size
									:maxlength="140"
								/>
							</a-form-item>
						</template>
						<template v-if="column.dataIndex === 'operate'">
							<a-button type="link" @click="handleDelete(index)">删除</a-button>
						</template>
					</template>
				</a-table>
			</a-form>
		</NoFormStatus>
	</FormItemRest>

	<FormItemRest>
		<NoFormStatus>
			<SelectProductsModal v-model:open="open" @confirm="handleAddSku" />
		</NoFormStatus>
	</FormItemRest>
</template>
